import CollectionName from '../utils/collections';
import BaseDocument from './BaseDocument';

/**
 * Class representing configurations of a user.
 *
 * @class Coach
 * @extends BaseDocument
 */
class Coach extends BaseDocument {
  constructor(id, opts) {
    super(`${CollectionName.COACH}/${id}`, opts);
  }

  /**
   * Get the time zone.
   * @return {string} The time zone name
   */
  get timeZone() {
    return this.data.timeZone;
  }

  /*
    *****************************************************************************************************************
    * WE SHOULD STOP DUPLICATING CODE THIS WAY> THE CHAT HAS ITS OWN VERSIONS OF THE DOCUMENTS> WE SHOULD MIGRATE ALL
    * THESE TO USE THE SAME MODEL.
    *****************************************************************************************************************
  */

  /**
   * Get the emojis skin tone.
   * @return {string} The emojis skin tone
   */
  get emojisSkinTone() {
    return this.data.emojisSkinTone;
  }

  setEmojisSkinTone(emojisSkinTone) {
    return this.updateFields({
      emojisSkinTone,
    });
  }

  /**
   * Get the coach's document by their id.
   *
   * @param {string} id - User id
   * @returns {Promise<UserConfig>} The coach document
   */
  static async getById(id) {
    const coachDoc = new Coach(id);
    await coachDoc.init();
    return coachDoc;
  }
}

export default Coach;
